import React from 'react';
import Carousel from '../components/Carousel';
import dummy1 from '../assets/Manglares/dummy1.jpg';
import dummy2 from '../assets/Manglares/dummy2.jpg';
import dummy3 from '../assets/Manglares/dummy3.jpg';
import '../styles/SoldOut.css';
import WhatsappCTA from '../components/WhatsappCTA';

const translations = {
  en: {
    title: "Manglares Residencial",
    subtitle: "A Sanctuary Where Nature and Coastal Living Converge",
    p1: "Immerse yourself in the tranquil beauty of Manglares Residencial, a distinctive coastal community in Oaxaca, showcasing over 70 carefully planned lots designed to seamlessly integrate with the surrounding natural splendor. This unique residential area is nestled amidst a captivating landscape of lush mangroves, offering residents a serene escape with breathtaking views that encompass both majestic mountain ranges and the vast, shimmering expanse of the Pacific Ocean",
    p2: "A thoughtfully embellished natural area within the community invites you to explore and appreciate the region's unique ecosystem, fostering a sense of harmony with the environment.",
    p3: "Enjoy the modern comforts of essential services, including readily available electricity and water supply, ensuring a seamless living experience. Situated less than 2 kilometers from the pristine shores of the beach and a convenient 15-minute drive from the international airport, Manglares Residencial offers the perfect balance of seclusion and accessibility.",
    p4: "Its proximity to the burgeoning El Origen and Vivo Resorts area, a destination poised for significant growth in Puerto Escondido, further enhances its appeal. Manglares Residencial presents an exceptional opportunity to embrace a vibrant coastal lifestyle, where the tranquility of nature harmonizes with the promise of future prosperity.",
    button: "Book",
    includes: "This Lot Includes:",
    includesp1: "Property Regimen Declaration: 'Bienes Comunales'",
    includesp2: "Water Rights and Usage",
    includesp3: "Electricity Rights and Usage",
    includesp4: "Amenities: No Amenities, but personalized entrance and designated green area space"
  },
  es: {
    title: "Manglares Residencial",
    subtitle: "Un Santuario donde la Naturaleza y la Vida Costera se Encuentran",
    p1: "Sumérgete en la belleza tranquila de Manglares Residencial, una comunidad costera única en Oaxaca, que presenta más de 70 lotes cuidadosamente planificados diseñados para integrarse perfectamente con el esplendor natural circundante. Esta área residencial única está enclavada en un paisaje cautivador de manglares frondosos, ofreciendo a los residentes un escape sereno con vistas impresionantes que abarcan tanto las majestuosas cadenas montañosas como la vasta y brillante extensión del Océano Pacífico.",
    p2: "Un área natural cuidadosamente embellecida dentro de la comunidad te invita a explorar y apreciar el ecosistema único de la región, fomentando una sensación de armonía con el medio ambiente.",
    p3: "Disfruta de las comodidades modernas de servicios esenciales, incluyendo electricidad y suministro de agua disponibles, asegurando una experiencia de vida sin complicaciones. Situado a menos de 2 kilómetros de las prístinas orillas de la playa y a un conveniente viaje de 15 minutos del aeropuerto internacional, Manglares Residencial ofrece el equilibrio perfecto entre aislamiento y accesibilidad.",
    p4: "Su proximidad al área en crecimiento de El Origen y Vivo Resorts, un destino preparado para un crecimiento significativo en Puerto Escondido, aumenta aún más su atractivo. Manglares Residencial presenta una oportunidad excepcional para adoptar un estilo de vida costero vibrante, donde la tranquilidad de la naturaleza se armoniza con la promesa de prosperidad futura.",
    button: "Reservar",
    includes: "Este Lote Incluye:",
    includesp1: "Propiedad: 'Bienes Comunales'",
    includesp2: "Uso de agua",
    includesp3: "Instalaciones para Electricidad CFE",
    includesp4: "Amenindades: No tiene amenidades, pero tiene entrada con caseta y área verde designada"
  }
};

const Manglares = ({ language }) => {
  return (
    <div className="testimonial">
      <div className="testimonial-text">
        <h1>{translations[language].title}</h1>
        
        <Carousel 
          image1={dummy1} 
          image2={dummy2}
          image3={dummy3}
        />
        
        <h2>{translations[language].subtitle}</h2>
        <p>{translations[language].p1}</p>
        <p>{translations[language].p2}</p>
        <p>{translations[language].p3}</p>
        <p>{translations[language].p4}</p>


        <h2>{translations[language].includes}</h2>
        <div className="callout-box">
        <p>📍 {translations[language].includesp1} </p>
        <p>📍 {translations[language].includesp2}  </p>
        <p>📍 {translations[language].includesp3}  </p>
        <p>📍 {translations[language].includesp4}  </p>
        </div>
      <WhatsappCTA language={language}/>

    </div>

  </div>
  );
};

export default Manglares;